import type { ReactNode } from 'react'

// Centred one-message page, used while loading and for the not-found screen.
export function FullPageMessage({ title, body, action }: { title: string; body?: string; action?: ReactNode }) {
  return (
    <main className="flex min-h-svh flex-col items-center justify-center gap-3 p-6 text-center">
      <h1 className="font-heading text-xl font-semibold">{title}</h1>
      {body ? <p className="max-w-sm text-muted-foreground">{body}</p> : null}
      {action}
    </main>
  )
}
